var hexColorRegex = /^#[\da-f]{3}(?:[\da-f]{3})?$/i;
/**
 * Converts a hex colour into an array of three numbers, where each number is the amount of red, green, and blue, respectively, in the given hex.
 *
 * @param {string} hex Hex colour code. Must be prefixed with # (e.g. #003cbe)
 * @returns {number[]} An array of three numbers, where each number is the amount of red, green, and blue, respectively, in the given hex.
 * @throws {RangeError}
 */

function getRgbParts(hex) {
  if (!hexColorRegex.test(hex)) {
    throw new RangeError("Expected a 3-digit or 6-digit hex number prefixed with #. Got: " + hex);
  }

  var hexDigits = hex.substring(1);

  if (hexDigits.length === 3) {
    hexDigits = hexDigits.split("").map(function (num) {
      return num + num;
    }).join("");
  }

  return [parseInt(hexDigits.substring(0, 2), 16), parseInt(hexDigits.substring(2, 4), 16), parseInt(hexDigits.substring(4, 6), 16)];
}
/**
 * Takes a hex colour code and opacity, then returns the rgba equivalent
 *
 * @param {string} hex Hex colour code. Must be prefixed with # (e.g. #003cbe)
 * @param {number} opacity Desired opacity. Must be between 0 and 1 (inclusive)
 * @returns {string} The RGBA equivalent of the given hex and opacity
 * @throws {RangeError}
 */


export function toRgba(hex, opacity) {
  if (typeof opacity !== "number" || isNaN(opacity) || opacity < 0 || opacity > 1) {
    throw new RangeError("Expect opacity to be a number between 0 and 1 (inclusive). Received: " + opacity);
  }

  var _getRgbParts = getRgbParts(hex),
      r = _getRgbParts[0],
      g = _getRgbParts[1],
      b = _getRgbParts[2];

  return "rgba(" + r + ", " + g + ", " + b + ", " + opacity + ")";
}
/**
 * Produces a hex colour that is {percentage} lighter or darker than the given {hex}.
 * Adapted from: https://css-tricks.com/snippets/javascript/lighten-darken-color/
 *
 * @param {string} hex Colour to lighten or darken. Must be given as a hex code (e.g. #003cbe).
 * @param {number} percentage Must be between -100 and 100. Positive percentage produces a lighter colour, negative percentage produces a darker colour.
 * @returns {string} Lightened or darkened colour.
 * @throws {RangeError}
 */

export function lightenOrDarkenColor(hex, percentage) {
  if (typeof percentage !== "number" || isNaN(percentage) || percentage < -100 || percentage > 100) {
    throw new RangeError("Expected percentage to be a number between -100 and 100. Received: " + percentage);
  }

  var amount = Math.round(2.55 * percentage);
  var shiftedParts = getRgbParts(hex).map(function (part) {
    return Math.max(Math.min(part + amount, 255), 0);
  });
  return shiftedParts.reduce(function (hex, part) {
    return hex + part.toString(16).padStart(2, "0");
  }, "#");
}